// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"fbb1bb33","310":"c25c69fe","327":"fbb1bb33","431":"fbb1bb33","567":"53079a1e","694":"53079a1e"}[chunkId] + ".chunk.css";
};